var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Aggregate",
    _vm._b(
      {
        attrs: {
          title: "Reserves",
          "error-messages": _vm.errorMessages,
          ItemConstructor: _vm.reserveFactory,
          "allow-edit": false,
        },
        on: {
          change: function ($event) {
            return _vm.$emit("change")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var item = ref.item
              var errors = ref.errors
              return [
                _c(
                  "div",
                  { staticClass: "pt-8 pr-8 max-width-1200" },
                  [
                    _c("InputYearly", {
                      attrs: {
                        "error-messages": _vm.$utils.getIfExists(errors, [
                          "requirements",
                        ]),
                        label: _vm.schema.requirements.title,
                        hint: _vm.schema.requirements.tooltip,
                        suffix: _vm.schema.requirements.unit,
                        num_years: _vm.num_years,
                        type: "number",
                        fill: "",
                        "fill-value": _vm.schema.requirements.items.default,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("change")
                        },
                      },
                      model: {
                        value: item.requirements,
                        callback: function ($$v) {
                          _vm.$set(item, "requirements", $$v)
                        },
                        expression: "item.requirements",
                      },
                    }),
                  ],
                  1
                ),
                _c("v-text-field", {
                  attrs: {
                    "error-messages": _vm.$utils.getIfExists(errors, [
                      "duration",
                      "messages",
                    ]),
                    label: _vm.schema.duration.title,
                    hint: _vm.schema.duration.tootltip,
                    suffix: _vm.schema.duration.unit,
                    min: _vm.schema.duration.minimum,
                    type: "number",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("change")
                    },
                  },
                  model: {
                    value: item.duration,
                    callback: function ($$v) {
                      _vm.$set(item, "duration", _vm._n($$v))
                    },
                    expression: "item.duration",
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.computedReserves,
          callback: function ($$v) {
            _vm.computedReserves = $$v
          },
          expression: "computedReserves",
        },
      },
      "Aggregate",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }